export const integraciones = {
    text1: "Integrações.",
    text2: "Entre em contato com os desenvolvedores para fazer alguma integração com seu",
    text3: "PMS",
    text4: "Contato",
    text5: "Solicitar integração",
    text6: "Dados coletados",
    text7: "Informações do solicitante",
    text8: "Nome",
    text9: "Motivo da solicitação",
    text10: "Escreva o motivo pelo qual você precisa da integração",
    text11: "Fechar",
    text12: "Enviar solicitação de integração",
    text13: "Registrado corretamente",
    text14: "Erro na solicitação",
};